import * as amplitude from '@amplitude/analytics-browser'

export const handleLocation = (url: string, track: string) => {
  amplitude.track(track)
  sessionStorage.clear()
  window.location.href = url
}
